
/**
 * Check if an error might indicate a security issue
 * @param error Any error object or string
 * @param securityIncidents Array to store security incidents
 * @returns boolean indicating if the error was security-related
 */
export const checkForSecurityImplications = (
  error: any, 
  securityIncidents: Array<{
    type: string;
    severity: 'low' | 'medium' | 'high';
    timestamp: Date;
    details: any;
  }>
): boolean => {
  const errorStr = error instanceof Error ? 
    error.message + (error.stack || '') : 
    String(error);
  
  // Look for patterns that might indicate security issues
  const securityPatterns = [
    { pattern: /injection/i, type: 'possible-injection', severity: 'high' as const },
    { pattern: /cross.*?site/i, type: 'possible-xss', severity: 'high' as const },
    { pattern: /cors/i, type: 'cors-issue', severity: 'medium' as const },
    { pattern: /token|auth|credential/i, type: 'auth-issue', severity: 'medium' as const },
    { pattern: /permission|denied|forbidden/i, type: 'permission-issue', severity: 'medium' as const }
  ];
  
  for (const { pattern, type, severity } of securityPatterns) {
    if (pattern.test(errorStr)) {
      // Log potential security incident
      const incident = {
        type,
        severity,
        timestamp: new Date(),
        details: { errorMessage: error instanceof Error ? error.message : String(error) }
      };
      
      securityIncidents.push(incident);
      
      // Log for monitoring
      console.warn(`[SECURITY ALERT] Potential ${type} detected`, incident);
      
      // For high severity issues, take immediate action 
      if (severity === 'high') {
        if (typeof window !== 'undefined') {
          // Only run this client-side
          import('sonner').then(({ toast }) => {
            toast.error("Security alert: Please contact support if this persists", {
              duration: 10000
            });
          });
        }
      }
      
      return true;
    }
  }
  
  return false;
};
